import { Injectable } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { IOrderInfo, IOrderResultService } from "./remoteOrderGroupPayResult.facade";
import { CheckoutService } from "../../services/checkout.service";


@Injectable()
export class RemoteOrderGroupPayResultService implements IOrderResultService {
  constructor(private _coreLogService: CoreLogService
    , private _checkoutService: CheckoutService
  ) { }

  public lastOrderInfo: IOrderInfo;

  /** Retrieves and maps the last order info from the checkout service. */
  public async loadLastOrderInfo(): Promise<IOrderInfo> {
    const me = this;
    try {
      const lastOrder = await me._checkoutService.getLastOrderInfo();
      let lastOrderInfo: IOrderInfo = {
        serviceTime: lastOrder.handoverTime,
        serviceDay: lastOrder.handoverDate,
        street: lastOrder.handoverStreet,
        orderid: lastOrder.id,
        locationPhonenumber: lastOrder.locTele,
        userEmail: lastOrder.customerMail
      };
      return lastOrderInfo; // Ensure the lastOrderInfo object is returned
    } catch (error) {
      me._coreLogService.error("RemoteOrderGroupPayResultService.ngOnInit", "_checkoutService.getLastOrderInfo", error);
      return Promise.reject(error); // Re-throw the error to ensure the promise is rejected
    }
  }

}
